import React from 'react';
import { motion } from 'framer-motion';
import { Search, FileCheck, Key } from 'lucide-react';
const steps = [{
  number: '01',
  icon: Search,
  title: 'Browse & Discover',
  description: 'Explore verified properties across Lagos, Abuja, and other prime locations.'
}, {
  number: '02',
  icon: FileCheck,
  title: 'Verify & Secure',
  description: 'Our team handles legal verification, documentation, and secure payment processing.'
}, {
  number: '03',
  icon: Key,
  title: 'Own & Manage',
  description: 'Complete your purchase and manage your property remotely through our dashboard.'
}];
export function HowItWorks() {
  return <section className="bg-white py-24 overflow-hidden" data-id="element-44">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-45">
        <div className="text-center mb-20" data-id="element-46">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl font-bold tracking-tight text-[#0F1B2D] sm:text-4xl" data-id="element-47">
            How It Works
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="mt-4 text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-48">
            Your journey to property ownership in three simple steps.
          </motion.p>
        </div>

        <div className="relative grid grid-cols-1 gap-12 md:grid-cols-3" data-id="element-49">
          {/* Connecting Line (Desktop) */}
          <div className="absolute top-12 left-0 hidden w-full md:block" data-id="element-50">
            <div className="h-0.5 w-full bg-slate-100 overflow-hidden" data-id="element-51">
              <motion.div initial={{
              width: '0%'
            }} whileInView={{
              width: '100%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.5,
              ease: 'easeInOut'
            }} className="h-full bg-[#E8531E]/20" data-id="element-52" />
            </div>
          </div>

          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.3
        }} className="relative flex flex-col items-center text-center group" data-id="element-53">
              <motion.div whileHover={{
            scale: 1.05
          }} className="relative z-10 mb-8 flex h-24 w-24 items-center justify-center rounded-full bg-white border-4 border-[#F8FAFC] shadow-sm transition-shadow duration-300 group-hover:shadow-md" data-id="element-54">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-[#E8531E]/10 text-[#E8531E]" data-id="element-55">
                  <step.icon className="h-8 w-8" data-id="element-56" />
                </div>
                <motion.div initial={{
              rotate: -45,
              opacity: 0
            }} whileInView={{
              rotate: 0,
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.5 + index * 0.3
            }} className="absolute -top-2 -right-2 flex h-8 w-8 items-center justify-center rounded-full bg-[#E8531E] text-sm font-bold text-white border-2 border-white" data-id="element-57">
                  {step.number}
                </motion.div>
              </motion.div>
              <h3 className="mb-3 text-xl font-bold text-[#0F1B2D]" data-id="element-58">
                {step.title}
              </h3>
              <p className="text-slate-600 leading-relaxed max-w-xs" data-id="element-59">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}